<template>
  <div>
    <i v-if="icon" class="material-icons no-padding left icon-color">{{ icon }}</i>
    <div class="item-description no-padding col s10 left" :style="darkTheme ? 'color: #bfbfbf' : 'color: #333333'">
      {{ label }}
    </div>
    <div class="switch no-padding right">
      <label>
        <input type="checkbox" :checked="value" @change="$emit('input', $event)" />
        <span class="lever" :style="{ backgroundColor: value ? layoutTheme.primaryColor : 'gray' }"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchInput",
  props: {
    value: Boolean,
    darkTheme: String,
    layoutTheme: Object,
    icon: String,
    label: String,
  },
  emits: ["input"],
};
</script>
